import fields, { columnCreatedOn, orderByColumns } from '@/constants/fields';
import {
  readStates, saveStates, updateStates,
} from '@/constants/lifecycle';
import { openEntityDialog, sortingFilters } from '@/constants/states';
import { hasKey } from '@/utils/resultsHelper';
import { pruneFieldErrors } from '@/utils/errors';
import findDataset from '../../state/shared';
import { ATTACHMENT_TYPE } from '../constants';

const attachmentsInitialState = () => ({
  downloadsInProgress: [],
  items: [],
  ...readStates,
  uploadsInProgress: [],
  url: [],
  ...saveStates,
  ...updateStates,
  updatingItems: {},
  filters: {
    byType: {
      [ATTACHMENT_TYPE.attachment.name]: true,
      [ATTACHMENT_TYPE.datafile.name]: true,
      [ATTACHMENT_TYPE.folder.name]: true,
    },
    byTextInput: '',
  },
  folders: {
    currentPathSegments: [],
  },
  ...sortingFilters([{ column: orderByColumns[columnCreatedOn], direction: 'asc' }]),
});

export const activeAttachmentInitialState = () => ({
  ...openEntityDialog,
  ...updateStates,
  attachment: {},
  isDirty: false,
});

export const activeFolderInitialState = () => ({
  ...openEntityDialog,
  folder: {},
});

export const createFolderInitialState = () => ({
  ...openEntityDialog,
  ...saveStates,
  folder: {},
  name: '',
});

export const dirtyAttachments = (attachments) => Boolean(
  attachments.uploadsInProgress.length || attachments.downloadsInProgress.length,
);

export const downloadableAttachmentConfirmationState = () => ({
  ...openEntityDialog,
  attachmentId: null,
  isFolder: false,
});

export const findDatasetAttachments = ({ datasets }, { category, code }) => {
  const item = findDataset({ datasets }, { category, code });
  return { item, attachments: item?.attachments, filters: item?.attachments?.filters };
};

export const pruneAttachmentErrors = (errors, { properties }) => {
  let filteredErrors = errors;

  if (properties.attachment && hasKey(properties.attachment.metadata, 'description')) {
    filteredErrors = pruneFieldErrors(filteredErrors, fields.DESCRIPTION);
  }

  return filteredErrors;
};

export default attachmentsInitialState;
